// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3epJf","label":"CategoryService_label__3l-WK","location":"CategoryService_location__U644-"};